/**
 * Dashboard layout: masthead plus a centered content column.
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Masthead } from "@/features/dashboard/components/masthead";
import { RouteGuard } from "@/components/auth/route-guard";

function DashboardLayout() {
  return (
    <div className="min-h-screen w-full bg-background">
      <RouteGuard>
        <div className="flex w-full flex-col">
          <Masthead />
          <main
            className="mx-auto w-full max-w-[1280px] px-4 pb-[calc(4rem+env(safe-area-inset-bottom))] pt-6 sm:px-7"
            role="main"
            aria-label="Dashboard content"
          >
            <Outlet />
          </main>
        </div>
      </RouteGuard>
    </div>
  );
}

export const Route = createFileRoute("/(app)/dashboard")({
  component: DashboardLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen items-center justify-center p-4">
      <div className="max-w-md text-center">
        <h1 className="font-display text-2xl text-brand">Something went wrong</h1>
        <pre className="mt-4 whitespace-pre-wrap text-left text-[13px] text-muted-foreground">{error.message}</pre>
      </div>
    </div>
  ),
});
